// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03346f77","595":"ba7373cf","708":"32776b87"}[chunkId] + ".chunk.js";
};